import 'bootstrap-select';
import facetSelection from './rbmc.facet-selection';

const sortProducts = {
    buildSelectMenu() {
        let $sortSelect = $('#js-select2Sort');

        if (!$sortSelect.length) {
            return;
        }

        facetSelection.actualSortingCode = $sortSelect[0].value;
        $sortSelect.selectpicker({
            style:      'btn-select btn-select--sort',
            dropupAuto: false
        });
    },
    bindHandler() {
        $('#js-select2Sort').on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let dataSet = e.target[clickedIndex].dataset;
            facetSelection.changeAndLoadURL(facetSelection.getSortURL(e.currentTarget.value));
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        sortProducts.buildSelectMenu();
        sortProducts.bindHandler();
    }
});

export default sortProducts;
